import React, { Component } from "react";
import { Spin, Icon } from "antd";
import Env from "../../../util/env";

export default class Auth extends Component {
  constructor(props) {
    super(props);

    if (localStorage.getItem('ACCESS_TOKEN')) {
      Env.login(() => {
        this.props.history.push('/');
      })
      return;
    }

    if (process.env.CHANNEL === "offline") {
      this.props.history.push('/');
      return;
    }

    const checkUrl = _.get(props, 'location.state.referrer', window.location.href)
    console.log("In Auth....");
    
    console.log(checkUrl)


    let returnedAuthCode = null;
    if (checkUrl) {
      let code = checkUrl.match(/code=(.*)&|code=(.*)$/);
      if (code) {
        returnedAuthCode = code[1].replace("&", "");
      }
    }

    let redirectUrl = checkUrl.match(/(.*)\/\?code.*$/);
    console.log("... redirect Url is:");
    console.log(redirectUrl);
    console.log(returnedAuthCode);
    if (_.isNil(returnedAuthCode)) {
      if ( !_.isNil(redirectUrl) && redirectUrl.indexOf("#/auth") > 0) {
        console.log(this.props.history);
        console.log("forward to root path");
        props.history.push("/");
      } else {
        console.log(" Auth code not found ...");
        Env.goAuth(window.location.origin + "/#/auth");
      }
    }

    if (!_.isNil(redirectUrl)) {
      redirectUrl = redirectUrl[1];
    }

    console.log(" Auth with code..." + returnedAuthCode);
    console.log(redirectUrl);
    Env.authWithCode(returnedAuthCode, redirectUrl, () => {
      this.props.history.push('/');
    });
  }

  componentDidMount() {
    console.log('=========== did mount')
    // window.location.href = 'http://oauth.newayz.com/show?response_type=code&state=wayz&client_id=2qOvUdnLbzTBT6OE0KrG9nTiSI&redirect_uri=http%3A%2F%2Flocalhost%3A3001'
  }

  render() {
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
    return (
      <div style={{ textAlign: "center", marginTop: 100 }}>
        <Spin indicator={antIcon} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Passport/Auth/index.jsx